import { SVGProps } from 'react';

const SearchIcon = ({
  height = '18px',
  width = '18px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 18 18'
    {...props}
  >
    <g
      id='Icons_Actions_ic-actions-search-2'
      data-name='Icons / Actions / ic-actions-search'
    >
      <rect
        id='Rectangle_157'
        data-name='Rectangle 157'
        width='18'
        height='18'
        fill='none'
      />
      <g id='ic-actions-search' transform='translate(2.672 2.638)'>
        <ellipse
          id='Ellipse_12'
          data-name='Ellipse 12'
          cx='5.166'
          cy='5.202'
          rx='5.166'
          ry='5.202'
          transform='translate(2.037)'
          fill='none'
          stroke='#9ca2a5'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth='2'
        />
        <line
          id='Line_50'
          data-name='Line 50'
          x1='3.602'
          y2='3.627'
          transform='translate(0 8.933)'
          fill='none'
          stroke='#9ca2a5'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth='2'
        />
      </g>
    </g>
  </svg>
);

export default SearchIcon;
